import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const TableRowMob = ({columns, data, reality, key}) => {
    const rootEl = useRef(null);
    const [menu, setMenu] = useState(false);
    const [open, setOpen] = useState(false);
    const realty = useSelector(state => state.realty);

    const formatter = new Intl.NumberFormat('ru-RU', {
        style: 'decimal', 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    useEffect(() => {
        const onClick = e => rootEl.current ? (rootEl.current.contains(e.target) || setMenu(false)) : ''
        document.addEventListener('click', onClick);
        return () => document.removeEventListener('click', onClick);
      }, []);


       
    const getDaysUntilEnd = (endDate) => {
        if (!endDate) return '-';
        
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        
        const end = new Date(endDate);
        end.setHours(0, 0, 0, 0);
        
        const timeDiff = end.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
    
        if (daysDiff > 0) {
            return `${daysDiff} ${getDayWord(daysDiff)}`;
        } else if (daysDiff === 0) {
            return '0'; 
        } else {
            return '0'; 
        }
    };

    const getDayWord = (days) => {
        const lastDigit = days % 10;
        const lastTwoDigits = days % 100;
        
        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return '';
        }
        if (lastDigit === 1) {
            return '';
        }
        if (lastDigit >= 2 && lastDigit <= 4) {
            return '';
        }
        return '';
    };


    const actions = () => {

        return (
            <div className={menu ? "actions  open" : "actions "} ref={rootEl}>
                <div className="actions__icon" onClick={() => setMenu(!menu)}>
                    <div></div>
                    <div></div>
                    <div></div>                    
                </div>
                <div className="actions__menu">
                    <div className="actions__close" onClick={() => setMenu(false)}></div>
                    <div className="actions__menu__item"><Link to="/change-access" state={{ id: data.id, fio: data.fio, group: {value: data.group, label: data.group == 'brocker' ? 'Брокер' : 'Администратор' } }}>Изменить права доступа</Link></div>
                    <div className="actions__menu__item">
                        <Link to={data.blacklist ? "/delete-blacklist" : "/add-blacklist"} state={{ id: data.id, fio: data.fio }}>{data.blacklist ? 'Удалить из черного списка' : 'Добавить в черный список'}</Link>
                    </div>
                    <div className="actions__menu__item"><Link to="/delete-agent" state={{ id: data.id, fio: data.fio }}>Удалить</Link></div>
                </div>
            </div>
        )
    }

    
    const action = () => {

        return (
            <div className="action-btns">
                <div className="action-btns__item action-btns__item_edit" onClick={() => setMenu(false)}>
                    <span>Редактировать</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path fill="#2D2D2C" d="M9.85377 2.02097C10.0487 1.826 10.0487 1.50104 9.85377 1.31607L8.68393 0.14623C8.49896 -0.0487432 8.174 -0.0487432 7.97903 0.14623L7.05916 1.0611L8.9339 2.93584M0 8.12526V10H1.87474L7.40397 4.46577L5.52923 2.59103L0 8.12526Z"/>
                    </svg>
                </div>
                <div className="action-btns__item action-btns__item_remove" onClick={() => setMenu(false)}>
                    <span>Удалить</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path fill="#2D2D2C" d="M9,9.8c-0.2,0-0.4-0.1-0.5-0.2l-8-8c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l8,8c0.3,0.3,0.3,0.8,0,1.1 C9.4,9.7,9.2,9.8,9,9.8z"/>
                    <path fill="#2D2D2C" d="M1,9.8c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l8-8c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-8,8 C1.4,9.7,1.2,9.8,1,9.8z"/>
                    </svg>
                </div>
            </div>
        )
    }
    
    return (
        <div className={open ? "table__tr booking-table-mob open" : "table__tr booking-table-mob"} onClick={() => !open && setOpen(!open)} key={key}>
            {columns.map(({ value, label }) => {

                let val;
                if(data[value] !== 'undefined') {
                    if(value === 'project') {
                        val = <>{data['project']}<div>{data['type']}</div></>
                    } 
                    else if(value === 'type') {
                        return
                    }
                    else if(value === 'group') {
                        val = data[value] === 'brocker' ? 'Брокер' : 'Администратор'
                    } 
                    else if(value === 'commission') {
                        val = new Intl.NumberFormat("ru-RU").format(data[value]) + " ₽"
                    } 
                    else if(value === 'amount') {
                        val = new Intl.NumberFormat("ru-RU").format(data[value]) + " ₽"
                    }  
                    else if(value === 'date' || value === 'dateAdd' || value === 'dateCheck' || value === 'dateStart' || value === 'dateEnd') {
                        val = data[value].split(" ")[0]
                    } 
                    //else if(value === 'date' || value === 'dateAdd' || value === 'dateCheck' || value === 'dateStart' || value === 'dateEnd') {
                    //    let date = new Date(data[value]);                  
                    //    val = (date.getDate() < 9 ? '0' : '') + date.getDate() + '.' + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + '.' + date.getFullYear()
                    //}
                    else if (value === 'projectId') {
                        const project = realty?.projects?.find(p => p.id === data?.projectId);
                        const projectName = project ? project?.name : 'Неизвестный проект';
                        const type = realty?.types?.find(t => t.id === data.typeId);
                        const typeName = type ? type.name : 'Неизвестный тип';
                    
                        val = (
                            <div>
                                <div>{projectName}</div>
                                <div>{typeName}</div>
                            </div>
                        );
                    }
                    else if(value === 'phone' || value === 'clientPhone') {
                        val = '+' + data[value][0] + ' (' + data[value][1] + data[value][2] + data[value][3] + ') ' +  + data[value][4] + data[value][5] + data[value][6] + ' ' + data[value][7] + data[value][8] + ' ' + data[value][9] + data[value][10]
                    } 
                    else if(value === 'blacklist') {
                        val = <div className="label">{data[value] ? 'в черном списке' : 'Активный'}</div>
                    } 
                    else if(value === 'formatId') {
                        val = data[value] == 1 ? 'Онлайн' : 'Офис'
                    } 
                    else if(value === 'status') {
                        val = <div className="label">{data[value]}</div>
                    }
                    
                    else if(value === 'actions') {
                        val = actions()
                    } 
                    else if(value === 'action') {
                        val = action()
                    } 
                    else if(value === 'result') {
                        val = data[value] ? 'УНИКАЛЬНЫЙ' : 'НЕ УНИКАЛЬНЫЙ'
                    }
                    //else if(value === 'days') {
                    //    val = getDaysUntilEnd(data['dateEnd']);
                    //}
                    else {
                        val = data[value]
                    }
                }
                
                return (
                    <div className="table__td">
                        <div className="table__title">{label}</div>
                        <div className="table__text">{val}</div>
                    </div>
                );
            })}
            <div className="table__arrow" onClick={() => setOpen(!open)}></div>
        </div>
    )
}

export default TableRowMob